(function () {
    'use strict';
    angular.module('app.core').config(['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state('property',
                {
                    url: '/:langcode/{path:property|emlak|inmueble|imovel}/:name?s',
                    templateUrl: 'app/property/property.html',
                    controller: 'PropertyController',
                    controllerAs: "vm",
                    params: {
                        langcode: {
                            value: ['$translate', function ($translate) {
                                return $translate.use();
                            }]
                        },
                        path: ['$translate', function ($translate) {
                            return $translate.instant("property_path");
                        }],
                        name: { type: 'any', raw: true },
                        s: { type: 'any', raw: true },
                    },
                    resolve: {
                        lazyLoad: ['$transition$', 'lazyLoadSvc', function ($transition$, lazyLoadSvc) {
                            return lazyLoadSvc.load($transition$, 'property');
                        }],

                        LangProtect: ['routeHelpers', function(routeHelpers) {
                            return routeHelpers.langProtect('property_path');
                        }],
                        endeksaId: ['$window', '$transition$', function ($window, $transition$) {
                            const path = $transition$.params().name;
                            return path.split('-')[path.split('-').length - 2] + '-' + path.split('-')[path.split('-').length - 1]
                        }],
                        property: [
                            "comparablesApiCached",
                            "$window",
                            "endeksaId",
                            "$transition$",
                            "$q",
                            function (
                                comparablesApiCached,
                                $window,
                                endeksaId,
                                $transition$,
                                $q
                            ) {
                                var deferred = $q.defer();
                                comparablesApiCached.detail({EndeksaId: endeksaId}).$promise.then(function (result) {
                                    deferred.resolve(result);
                                }, function () {
                                    deferred.reject($transition$.router.stateService.go($transition$.to().name, { langcode: $transition$.params().langcode }));
                                })
                                return deferred.promise;
                            },
                        ],
                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("properties");
                            $translatePartialLoader.addPart("analysis_houseOpportDetail");
                            $translatePartialLoader.addPart("opportunity");
                            $translatePartialLoader.addPart("property_details");
                            $translatePartialLoader.addPart("analysis_layout");
                            $translatePartialLoader.addPart("analysis_projects");
                            return $translate.refresh();
                        }],
                        title: ['property', function (property) {
                            return property.Title;
                        }],
                        description: ['$translate', function ($translate) {
                            return $translate('p_description').then(function (res){
                               return  res
                           })
                       }]
                    },
                    metaTags: {
                        title: '{{title}}',
                        description: '{{description}}',
                        robots: 'noindex, nofollow',
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    }
                })
    }]);

})();
